import { css } from "styled-components"

const families = {
  // https://fonts.google.com/specimen/Jost
  primary: `"Jost", "Arial", "Helvetica Neue", "Helvetica", sans-serif`,
  secondary: `"Jost", "Arial", "Helvetica Neue", "Helvetica", sans-serif`,
}

const weights = {
  primary: {
    normal: 400,
    medium: 500,
    semibold: 600,
    bold: 700,
  },
  secondary: {
    normal: 400,
    medium: 500,
    semibold: 600,
    bold: 700,
  },
}

const set = (family, weight) => {
  try {
    return css`
      font-family: ${families[family]};
      font-weight: ${weights[family][weight]};
    `
  } catch (e) {
    // eslint-disable-next-line no-console
    return console.error(`Undefined font family/weight`, e.message, e.name)
  }
}

export default {
  set,
}
